import { motion } from 'framer-motion';
import SiteMeta from '../components/SiteMeta';
import { useNavigation } from '../context/NavigationContext';
import WorkTable from '../components/WorkTable';
import Footer from '../components/Footer';
import Lottie from 'lottie-react';
import { useRef, useEffect, useState } from 'react';
import './Work.css';

function Work() {
  const { destinationPage, activePage, clearDestination, isNavigatingToCaseStudy } = useNavigation();
  const isDestination = destinationPage === 'work';
  const isActive = activePage === 'work';
  const lottieRef = useRef();
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    // Try loading the animation data
    fetch('/src/assets/lottie_animations/Cases.json')
      .then(response => response.json())
      .then(data => {
        setAnimationData(data);
      })
      .catch(error => {
        console.error('Error loading animation:', error);
        // Fallback to direct import
        import('../assets/lottie_animations/Cases.json')
          .then(module => {
            setAnimationData(module.default);
          })
          .catch(importError => {
            console.error('Error importing animation:', importError);
          });
      });
  }, []);

  useEffect(() => {
    if (animationData && lottieRef.current) {
      setTimeout(() => {
        lottieRef.current.play();
      }, 300);
    }
  }, [animationData]);

  return (
    <>
      <SiteMeta
        title="Work - Robin Gardeur (le Shka)"
        description="Explore my portfolio of creative projects, brand identities, and immersive digital experiences across 15 years working with 100+ clients."
      />
      <motion.div
        className={`page ${isDestination ? 'page-transitioning' : ''} ${isActive ? 'page-active' : ''} ${isNavigatingToCaseStudy ? 'page-fade-to-white' : ''}`}
        initial={{ y: '100vh' }}
        animate={{ y: 0 }}
        exit={{ y: '-20vh' }}
        transition={{
          duration: 1,
          ease: [0.4, 0, 0.2, 1], // Custom easing for smoother motion
          type: "tween"
        }}
        onAnimationComplete={() => {
          if (isDestination) {
            clearDestination();
          }
        }}
      >
      <div className="title work-title">
        {animationData ? (
          <Lottie 
            lottieRef={lottieRef}
            animationData={animationData}
            loop={false}
            autoplay={false}
            style={{ width: 'auto', height: 'auto' }}
          />
        ) : (
          <h1>Cases</h1>
        )}
      </div>
      <WorkTable />
      <Footer />
      </motion.div>
    </>
  );
}

export default Work;